



















import { Component } from 'vue-property-decorator';
import MixinMain from '@/mixing/MixinMain.vue';

@Component({
		name: 'MainInicio',
        components: {

    }})

    export default class MainInicio extends MixinMain {
        public title = this.$t("FormDialog.welcomeText");
    }
